var AnimationManager = /** @class */ (function () {
    function AnimationManager() {
        this.map = {};
        this.running = false;
    }
    AnimationManager.prototype.register = function (ex) {
        this.map[ex.getId()] = ex;
        this.run();
    };
    AnimationManager.prototype.unregister = function (ex) {
        delete this.map[ex.getId()];
    };
    AnimationManager.prototype.tick = function () {
        var _this = this;
        var animations = Object.keys(this.map).map(function (item) { return _this.map[item]; });
        if (!animations.length) {
            this.running = false;
            return;
        }
        var transformMap = {};
        animations.forEach(function (animation) {
            var needUpdate = animation.tick();
            if (needUpdate) {
                var transform = animation.getTransform();
                transformMap[transform.getId()] = transform;
            }
        });
        Object.keys(transformMap).forEach(function (key) { return transformMap[key].updateAnimationStyle(); });
        requestAnimationFrame(function () { return _this.tick(); });
    };
    AnimationManager.prototype.run = function () {
        var _this = this;
        if (this.running) {
            return;
        }
        requestAnimationFrame(function () { return _this.tick(); });
    };
    AnimationManager.manager = new AnimationManager();
    return AnimationManager;
}());
export { AnimationManager };
